export default __webpack_public_path__ + "static/media/health-check-graphic.7be4720e.png";